var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-content",on:{"click":_vm.handelToPersonalizedPage}},[_vm._v(" "+_vm._s(_vm.$t('admin.hrDashboard.btn.personalize'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }